module.exports = __webpack_public_path__ + "static/media/18.e8dfc05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/18.png
// module id = 1391
// module chunks = 0